import {createContext} from 'react';

const FormTranslationKeyContext = createContext<string>('forms.unknown');

export default FormTranslationKeyContext;